import { BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxBootstrapLocaleMappingService } from 'assets/ngx-bootstrap/ngx-bootstrap-locale-mapping.service';
import { 
    defineLocale,
    arLocale, bgLocale, caLocale, csLocale, daLocale, deLocale, enGbLocale,
    esDoLocale, esLocale, esPrLocale, esUsLocale, etLocale, fiLocale, frLocale,
    glLocale, heLocale, hiLocale, huLocale, hrLocale, idLocale, itLocale,
    jaLocale, kaLocale, kkLocale, koLocale, ltLocale, lvLocale, mnLocale,
    nbLocale, nlBeLocale, nlLocale, plLocale, ptBrLocale, roLocale, ruLocale,
    skLocale, slLocale, sqLocale, svLocale, thLocale, thBeLocale, trLocale,
    ukLocale, viLocale, zhCnLocale
} from 'ngx-bootstrap/chronos';
import { ThemeHelper } from '@app/shared/layout/themes/ThemeHelper';

export class NgxBootstrapDatePickerConfigService {

    private static getLocaleData(supportedLocale: string, moduleLocaleName: string): any {
        const localeMap: { [key: string]: any } = {
            'ar': arLocale,
            'bg': bgLocale,
            'ca': caLocale,
            'cs': csLocale,
            'da': daLocale,
            'de': deLocale,
            'en-gb': enGbLocale,
            'es-do': esDoLocale,
            'es': esLocale,
            'es-pr': esPrLocale,
            'es-us': esUsLocale,
            'et': etLocale,
            'fi': fiLocale,
            'fr': frLocale,
            'gl': glLocale,
            'he': heLocale,
            'hi': hiLocale,
            'hu': huLocale,
            'hr': hrLocale,
            'id': idLocale,
            'it': itLocale,
            'ja': jaLocale,
            'ka': kaLocale,
            'kk': kkLocale,
            'ko': koLocale,
            'lt': ltLocale,
            'lv': lvLocale,
            'mn': mnLocale,
            'nb': nbLocale,
            'nl-be': nlBeLocale,
            'nl': nlLocale,
            'pl': plLocale,
            'pt-br': ptBrLocale,
            'ro': roLocale,
            'ru': ruLocale,
            'sk': skLocale,
            'sl': slLocale,
            'sq': sqLocale,
            'sv': svLocale,
            'th': thLocale,
            'th-be': thBeLocale,
            'tr': trLocale,
            'uk': ukLocale,
            'vi': viLocale,
            'zh-cn': zhCnLocale
        };
        
        return localeMap[supportedLocale.toLowerCase()];
    }

    static getDaterangepickerConfig(): BsDaterangepickerConfig {
        return Object.assign(new BsDaterangepickerConfig(), {
            containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getTheme()
        });
    }

    static getDatepickerConfig(): BsDatepickerConfig {
        return Object.assign(new BsDatepickerConfig(), {
            containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getTheme()
        });
    }

    static getTheme(): string {
        return ThemeHelper.getTheme();
    }

    static getDatepickerLocale(): BsLocaleService {
        let localeService = new BsLocaleService();
        localeService.use(abp.localization.currentLanguage.name);
        return localeService;
    }

    static registerNgxBootstrapDatePickerLocales(): Promise<boolean> {
        if (abp.localization.currentLanguage.name === 'en') {
            return Promise.resolve(true);
        }

        let supportedLocale = new NgxBootstrapLocaleMappingService().map(abp.localization.currentLanguage.name).toLowerCase();
        let moduleLocaleName = new NgxBootstrapLocaleMappingService().getModuleName(abp.localization.currentLanguage.name);

        return new Promise<boolean>((resolve, reject) => {
            try {
                const localeData = NgxBootstrapDatePickerConfigService.getLocaleData(supportedLocale, moduleLocaleName);
                if (localeData) {
                    defineLocale(abp.localization.currentLanguage.name.toLowerCase(), localeData);
                    resolve(true);
                } else {
                    console.warn(`Locale ${supportedLocale} not found, falling back to English`);
                    resolve(true);
                }
            } catch (error) {
                reject(error);
            }
        });
    }
}
